"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const redux_observable_1 = require("redux-observable");
const current_1 = require("./current");
const list_1 = require("./list");
const comment_1 = require("./comment");
const print_1 = require("./print");
const jobs_1 = require("./jobs");
const stats_1 = require("./stats");
const _folderList = require("../../modules/files/list/epics");
const entryFolderList = _folderList.default('entry-files');
const imagesFolderList = _folderList.default('entry-images');
exports.allEpics = redux_observable_1.combineEpics(
// Current
current_1.fetchDiaryentry, current_1.handleCreateWorksiteDiaryEntry, current_1.handleUpdateWorksiteDiaryEntry, 
// List
list_1.fetchDiaryEntries, list_1.deleteDiaryEntry, list_1.removeEntrySignatures, 
// Comments
comment_1.fetchDiaryEntryComments, comment_1.handleCreateWorksiteDiaryEntryComment, 
// Print
print_1.fetchDiaryEntriesToPrint, 
// Jobs
jobs_1.fetchDiaryEntryJobs, jobs_1.handleCreateWorksiteDiaryJobs, 
// Stats
stats_1.fetchDiaryStats, 
// Files
entryFolderList.fetch, imagesFolderList.fetch);
//# sourceMappingURL=index.js.map